import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from '../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';

const defaultSorted = [{ dataField: 'code', order: 'desc' }];
const List = (props) => {
  const { entities, totalCount, intl, setQueryParams, listLoading } = props;
  const saleAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.SALESAMOUNT',
  });
  const profitAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.PROFITAMOUNT',
  });
  const lostAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.LOSTAMOUNT',
  });
  const preOrderAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.PREORDERAMOUNT',
  });
  const shipAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.SHIPAMOUNT',
  });
  const deliveredAmountLabel = intl.formatMessage({
    id: 'FINANCE.SALES.LABEL.DELIVEREDAMOUNT',
  });

  // Table columns
  const columns = [
    {
      dataField: 'salesAmount',
      text: saleAmountLabel,
      sort: false,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-primary',
    },
    {
      dataField: 'profitAmount',
      text: profitAmountLabel,
      sort: false,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-success',
    },
    {
      dataField: 'lostAmount',
      text: lostAmountLabel,
      sort: false,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-danger',
    },
    {
      dataField: 'preOrderAmount',
      text: preOrderAmountLabel,
      sort: false,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-warning',
    },
    {
      dataField: 'shipAmount',
      text: shipAmountLabel,
      sort: false,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-info',
    },
    {
      dataField: 'deliveredAmount',
      text: deliveredAmountLabel,
      sort: false,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-success',
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPage: 400,
    page: 1,
  };
  return (
    <BootstrapTable
      key='financeSalesTotal'
      wrapperClasses='table-responsive'
      bordered={false}
      classes='table table-head-custom table-vertical-center overflow-hidden'
      bootstrap4
      local
      keyField='salesAmount'
      data={entities === null ? [] : entities}
      columns={columns}
      defaultSorted={defaultSorted}
      onTableChange={getHandlerTableChange(setQueryParams)}
    >
      <PleaseWaitMessage entities={entities} />
      <NoRecordsFoundMessage entities={entities} />
    </BootstrapTable>
  );
};

export default injectIntl(List);
